import $ from 'jquery';
import {Collection, View} from 'backbone';
import packageSortTemplate from '../../templates/common/packageSortTemplate.hbs';
import {getUrlParameter} from '../../sinclair/sinclair.utils';

import React from 'react';
import ReactDOM from 'react-dom';
import {PackageSort} from '@sinclair-digital/sbg-storyline-components/src/components/PackageSearch/PackageSort';

export const assignSortOptionsFromUrl = sortOptions => {
    const urlSortColumn = getUrlParameter('sortBy')[0];
    const urlSortDirection = getUrlParameter('sortOrder')[0];

    if (!urlSortColumn || !urlSortDirection) {
        return sortOptions;
    }

    return sortOptions.map(sortOption => {
        if (sortOption.sortColumn.toLowerCase() !== urlSortColumn.toLowerCase()) {
            return Object.assign({}, sortOption, {
                selected: false,
            });
        }

        return Object.assign({}, sortOption, {
            selected: true,
            sortDirection: urlSortDirection,
        });
    });
};

export default View.extend({
    template: packageSortTemplate,
    el: '.js-sda-PackageSort',
    sortOptions: [
        {
            sortColumn: 'Date',
            text: 'last saved',
            sortDirection: 'descending',
            selected: true,
        },
        {
            sortColumn: 'Headline',
            text: 'headline',
            sortDirection: 'descending',
        },
    ],
    initialize(opts) {
        opts = opts || {};

        if (opts.sortOptions) {
            this.sortOptions = opts.sortOptions;
        } else {
            this.sortOptions = assignSortOptionsFromUrl(this.sortOptions);
        }

        if (opts.el) {
            this.el = opts.el;
            this.$el = $(opts.el);
        }

        this.collection = new Collection(this.sortOptions);
        this.selected = this.collection.findWhere({selected: true});
        if (this.selected) {
            this.initialState = Object.freeze({sort: this.selected, direction: this.selected.get('sortDirection')});
        }
        this.render();
    },
    render() {
        ReactDOM.render(
            <PackageSort
                sortOptions={this.collection.toJSON()}
                sortHandler={(...args) => this.changeSortHandler(...args)}
            />,
            this.$el[0],
        );
    },
    reset() {
        this.selected.set({selected: false});
        this.selected = this.initialState.sort;
        this.selected.set({sortDirection: this.initialState.direction});
        this.render();
    },
    triggerChange() {
        const sortObj = this.selected.toJSON();
        this.$el.trigger('change.sort', `${sortObj.sortDirection}${sortObj.sortColumn}`);
    },
    changeSortHandler(newScopeOptions) {
        this.collection.set(newScopeOptions);
        this.selected = this.collection.find(option => option.get('selected'));
        this.triggerChange();
        this.render();
    },
    getSortDirection() {
        return this.selected ? this.selected.get('sortDirection') : undefined;
    },
    getSortColumn() {
        return this.selected ? this.selected.get('sortColumn') : undefined;
    },
    getSortValue() {
        if (!this.selected) {
            return undefined;
        }
        const sortObj = this.selected.toJSON();
        return `${sortObj.sortDirection}${sortObj.sortColumn}`;
    },
});
